import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-5 text-center">
          2014
        </p>
        
        <p class="poem-block mb-3">
          Уже никто не пишет стихов, где есть рифма, ритм иль хотя бы заглавные буквы и точки.<br/>
          Уже никто не стремится выразить мысль максимально точно.<br/>
          Уже никто не будет чертить архитектурные планы вручную:<br/>
          Ведь это просто глупо – делать «работу дурную»!
        </p>
        
        <p class="poem-block mb-5">
          Уже никто не умеет в уме подсчитывать сдачу,<br/>
          Уже никто не посмеет высказать мысль наудачу,<br/>
          Не проконсультировавшись в Интернете, не узнавши, чтó нынче в моде:<br/>
          Кто ж захочет быть одиночкой и ненормальным вроде?
        </p>
        
        
        <p class="poem-block mb-5 text-center">
          2034
        </p>
        
        
        <p class="poem-block mb-3">
          Уже никто не хочет ходить своими ногами,<br/>
          Как можно было так издеваться над нами,<br/>
          Чтобы весь вес весьма корпулентного тела<br/>
          Носили две тонкие палки, давно уж оставшиеся без дела?!
          
        
        <p class="poem-block mb-5">
          Уже никто не готовит еду в своём доме,<br/>
          Ведь и еды уже никакой не осталось, кроме<br/>
          Той, что нам раздают по сети социальной защиты<br/>
          По трубам, тёплую, переваренную, по расписанию прямо в рот, чтобы были мы сыты.
        
        
        <p class="poem-block mb-5 text-center">
          * * *
        </p>

        
        <p class="poem-block mb-3">
          Вот прилетел я на Землю, Фортинбрас с далёкой планеты,<br/>
          Но на Земле уже не остались Гамлèты,<br/>
          Не с кем сражаться, некого завоевать в этой убогой юдóли…<br/>
          Видно, нe заслужила Земля лучшей доли.
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Естественная эволюция'
}
const itemDate = {
  rus: 'Июль 2018'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;